<template>
  <Dialog class="OfferEditModal" :hide-close-button="true" v-bind="$attrs">
    <template #header-title> Editar condições </template>
    <template #content>
      <p>
        No momento, não é possível alterar as condições aqui na Juros Baixos.
        Mas não se preocupe! Você pode alterar com a NoVerde após solicitar a
        oferta.
      </p>
    </template>
    <template #footer>
      <Button @click="closeAction">Entendi</Button>
    </template>
  </Dialog>
</template>
<script>
import { mapActions } from 'vuex'
import Button from '@/aasgard/components/buttons/Button.vue'
import Dialog from '@/aasgard/components/modals/Dialog.vue'
export default {
  name: 'OfferEditModal',
  components: {
    Button,
    Dialog,
  },
  emits: ['close'],
  data() {
    return {
      clickOkButtonEvent: {
        eventLabel: 'fakedoor-noverde-edit-details',
        eventCategory: 'fakedoor-noverde-edit-details',
        eventAction: 'click-ok-modal',
      },
    }
  },
  methods: {
    ...mapActions({
      actEmitGaEvent: 'services/ga/actEmitGaEvent',
    }),
    closeAction() {
      this.actEmitGaEvent(this.clickOkButtonEvent)
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss">
.OfferEditModal {
  & > .content-wrapper {
    padding: 8px;

    & > .content {
      & > p {
        @include body-2;
        margin: 4px 0;
      }
    }
  }
}
</style>
